/* "Load more" for collection pages.

   The grid used to render 250 products with the page - about 4.6MB of HTML on
   a large collection, and seconds before anything appeared. It now renders 60
   and this fetches the rest 30 at a time, on demand.

   Shopify's `paginate` takes a single page size, so "60 then 30" cannot come
   from one loop. The page paginates by 60; templates/collection.loadmore
   paginates the same collection by 30, and the button asks it for the page
   that continues where the rendered products stop - page 3 after 60, page 4
   after that, and so on. Liquid writes the starting page onto the button.

   The current query string is forwarded with every request, so sorting and
   filters keep applying; Shopify applies them to collection.products whatever
   view renders it.

   Progressive enhancement: with JavaScript off, the <noscript> link beside the
   button is a real paginate.next url, so the collection is still walkable and
   crawlable. */
(function () {
  var GRID = '#AjaxinateLoop';

  function setup(btn) {
    if (btn.getAttribute('data-loadmore-ready')) return;
    btn.setAttribute('data-loadmore-ready', '1');

    var wrap = btn.closest('[data-loadmore-wrap]');
    var label = btn.querySelector('[data-loadmore-label]');
    var spinner = btn.querySelector('.dodo-loadmore__spinner');
    var base = btn.getAttribute('data-collection-url');
    var page = parseInt(btn.getAttribute('data-next-page'), 10) || 2;
    var busy = false;

    function url(p) {
      /* The base is built with URL rather than string-concatenated, because
         collection.url does not always end at the path: a vendor listing is
         /collections/vendors?q=MEDICUBE, already carrying a query. Appending
         "?view=..." to that produced a second "?", so view= was swallowed into
         the q value, the request returned the full themed page instead of the
         bare card list, and every .product-grid-item on it - recommendation
         rails included - got appended. That is where the other brands came
         from.

         The collection's own params are kept, the address bar's sort and
         filters are layered on top, and `page` is dropped so the one in the
         address bar cannot fight the one being requested. */
      var u = new URL(base, window.location.origin);
      var current = new URLSearchParams(window.location.search);
      current.delete('page');
      current.forEach(function (value, key) { u.searchParams.set(key, value); });
      u.searchParams.set('view', 'loadmore');
      u.searchParams.set('page', p);
      return u.pathname + '?' + u.searchParams.toString();
    }

    function done() {
      if (wrap) wrap.remove();
    }

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      if (spinner) spinner.hidden = false;

      fetch(url(page), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var grid = document.querySelector(GRID);
          if (!grid) return done();

          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* The view renders bare cards with no layout. Anything carrying the
             grid wrapper is a full page, which means the view did not apply -
             appending from it would pull in cards from every other section on
             that page. Stop rather than show the wrong products. */
          if (doc.querySelector('#AjaxinateLoop')) return done();

          var cards = doc.querySelectorAll('.product-grid-item');
          var last = doc.querySelector('[data-loadmore-end]');

          if (!cards.length) return done();

          var frag = document.createDocumentFragment();
          for (var i = 0; i < cards.length; i++) frag.appendChild(cards[i]);
          grid.appendChild(frag);

          page += 1;
          btn.setAttribute('data-next-page', page);

          /* Let the theme bring in the new cards' lazy images and rebind
             anything that watches the grid. */
          if (window.lazySizes && window.lazySizes.loader &&
              window.lazySizes.loader.checkElems) {
            window.lazySizes.loader.checkElems();
          }
          document.dispatchEvent(new CustomEvent('dodo:loadmore:appended', {
            bubbles: true, detail: { count: cards.length }
          }));

          /* The view marks its own last page, rather than this inferring it
             from a short batch - a collection sized an exact multiple of 30
             would otherwise look like it had more to give. */
          if (last) done();
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          if (spinner) spinner.hidden = true;
        });
    });
  }

  function init() {
    var btns = document.querySelectorAll('[data-loadmore-btn]');
    for (var i = 0; i < btns.length; i++) setup(btns[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* The grid re-renders when a filter or sort is applied, which replaces the
     button with a fresh one carrying a new starting page. */
  document.addEventListener('theme:filters:updated', init);
  document.addEventListener('shopify:section:load', init);
})();
